import { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  #DSG_wrapper_extra {
    #collapsable-content {
      .content-wrap {
        display: none;
        user-select: none;
      }

      .toggleControler {
        user-select: none;
      }
    }
  }
`;

export default class HeaderBannerWithCollapsableContent extends Component {
  constructor(props) {
    super(props);

    this.bannerRef = createRef();
  }

  componentDidMount() {
    if (this.bannerRef.current) {
      const anchorButton = this.bannerRef.current.querySelector('.toggleControler');
      const collapsableContent = this.bannerRef.current.querySelector('.content-wrap');

      if (anchorButton && collapsableContent) {
        anchorButton.addEventListener('click', (e) => {
          e.preventDefault();

          if (window.getComputedStyle(collapsableContent).display === 'none') {
            collapsableContent.style.display = 'block';
          } else {
            collapsableContent.style.display = 'none';
          }
        });
      }
    }
  }

  render() {
    return (
      <Wrapper
        ref={this.bannerRef}
        dangerouslySetInnerHTML={{ __html: this.props.htmlContent }}
        style={{ paddingBottom: '10px' }}
      />
    );
  }
}

HeaderBannerWithCollapsableContent.displayName = 'HeaderBannerWithCollapsableContent';

HeaderBannerWithCollapsableContent.propTypes = {
  htmlContent: PropTypes.string.isRequired
};
